// Generic slide-in drawer chrome (open/close, focus trap, outside-click and
// Escape to dismiss) shared by every gift-option style popup: the PDP's
// engraving/gift-wrap drawers and Add to Cart review popup (gift-options.js)
// and the cart page's engraving editor (cart-engraving.js). Pulled out of
// gift-options.js so pages that only need the cart editor (no gift wrap,
// no Swiper) don't have to load that file's Swiper import.
if (!customElements.get('gift-option-drawer')) {
  customElements.define(
    'gift-option-drawer',
    class GiftOptionDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(event) {
        const target = event.target;
        if (
          target !== this &&
          !target.closest('gift-option-drawer') &&
          !target.closest(
            '[data-engraving-toggle], [data-engraving-edit], [data-giftwrap-toggle], [data-giftwrap-edit], engraving-edit-button, [data-trust-badge-toggle], cart-remove-button, gift-wrap-toggle-button, gift-wrap-summary'
          )
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        // Only clear overflow-hidden if this drawer was the one that set it -
        // e.g. the cart page's engraving editor can open while the cart
        // drawer (also overflow-hidden while open) is open underneath it, and
        // closing just the editor shouldn't un-lock scroll out from under
        // the still-open cart drawer.
        if (!this.bodyOverflowWasAlreadyHidden) document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement, elementToFocus) {
        this.focusElement = focusElement;
        this.bodyOverflowWasAlreadyHidden = document.body.classList.contains('overflow-hidden');
        this.setAttribute('open', '');
        // Deferred a tick: show() can be called mid-bubble of the very click that's
        // opening this drawer (e.g. mobile's sticky Add to Cart bar proxies its click
        // to the real, off-screen submit button, which triggers this synchronously
        // before that original click finishes bubbling to body). Attaching the
        // outside-click listener immediately would catch that same still-bubbling
        // click and instantly close the drawer it just opened.
        setTimeout(() => {
          if (this.hasAttribute('open')) document.body.addEventListener('click', this.onBodyClick);
        });
        document.body.classList.add('overflow-hidden');
        // trapFocus(this, elementToFocus || this);
      }
    }
  );
}
